export default class EqualHeight {
  constructor() {
    EqualHeight.init();
  }

  static init() {
    EqualHeight.normalizeImageHeights();
    window.addEventListener('resize', () => {
      EqualHeight.normalizeImageHeights();
    });
  }

  static normalizeImageHeights(timeoutDuration = 50) {
    window.setTimeout(() => {
      EqualHeight.equalize(document.querySelectorAll('.js-address'));
      document.querySelectorAll('.grid').forEach(grid => {
        EqualHeight.equalize(grid.querySelectorAll('.hero'));
        EqualHeight.equalize(grid.querySelectorAll('.js-image_card-image'));
      });
    }, timeoutDuration);
  }

  static equalize(elements) {
    if (!elements.length) return;

    let tallest = 0;
    elements.forEach(el => {
      el.style.height = 'auto';
      const height = el.clientHeight;
      if (height > tallest) {
        tallest = height;
      }
    });

    elements.forEach(el => {
      el.style.height = `${tallest}px`;
    });
  }
}
